import DSTopics from "./DSTopics"

export default function DataStructures()
{
    return(
        <div className="pt-40" id="dataStructures">
            <h2 className="text-4xl pb-20 text-center">Data Structures</h2>
            <DSTopics/>
        </div>
    )
}